export const SCRIPT_HEADER_NOTICES = [
  'Variables used by Scriptable.',
  'These must be at the very top of the file. Do not edit.',
];
